<template>
  <div class="container">
    <div
      v-for="cert in certs"
      :key="cert.key"
      class="isoWrapper"
      @click="openCert(cert)"
    >
      <img class="iso" :src="cert.img" :alt="cert.alt" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Certs',
  computed: {
    lang() {
        return this.$store.state.lang;
    },
    certs() {
      const pdfBase = 'static/certificates/full';
      const imgBase = 'static/certificates/badge';
      const isPl = this.lang === 'pl';

      return [
        {
          key: 'iso45001',
          alt: 'ISO 45001',
          img: `${imgBase}/${isPl ? 'ISO-45001-PL.png' : 'ISO-45001-ENG.png'}`,
          pdf: `${pdfBase}/${isPl ? 'ISO-45001-PL.pdf' : 'ISO-45001-ENG.pdf'}`,
        },
        {
          key: 'iso27001',
          alt: 'ISO 27001',
          img: `${imgBase}/${isPl ? 'ISO-IEC-27001-PL.png' : 'ISO-IEC-27001-ENG.png'}`,
          pdf: `${pdfBase}/${isPl ? 'ISO-IEC-27001-PL.pdf' : 'ISO-IEC-27001-ENG.pdf'}`,
        },
        {
          key: 'iso14001',
          alt: 'ISO 14001',
          img: `${imgBase}/${isPl ? 'ISO_14001-POL.png' : 'ISO_14001-ENG.png'}`,
          pdf: `${pdfBase}/${isPl ? 'ISO_14001-POL.pdf' : 'ISO_14001-ENG.pdf'}`,
        },
        {
          key: 'iso9001',
          alt: 'ISO 9001',
          img: `${imgBase}/${isPl ? 'ISO_9001-POL.png' : 'ISO_9001-ENG.png'}`,
          pdf: `${pdfBase}/${isPl ? 'ISO_9001-POL.pdf' : 'ISO_9001-ENG.pdf'}`,
        },
      ];
    },
  },
  methods: {
    openCert(cert) {
      window.open(cert.pdf, '_blank');
    },
  }
}
</script>

<style scoped>
    .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 50px;
    }
    .isoWrapper {
    cursor: pointer;
    }
    .iso {
    min-width: 15mm;
    max-width: 200px;
    height: auto;
    margin: 10px;
    display: block;
    }
</style>



// WEBPACK FOOTER //
// Certs.vue?4d946152